import React from "react";
import { useUserCurrency } from "../../hooks/useUserCurrency";

const UserCurrencyDisplay = ({
  usdAmount,
  userId,
  className = "font-body",
  showCurrency = true,
  precision = 2,
  loading: externalLoading = false,
}) => {
  const {
    formatUserAmount,
    convertUSDToUserCurrency,
    loading,
    error,
    isLoaded,
  } = useUserCurrency(userId);

  if (!isLoaded || loading || externalLoading) {
    return (
      <span
        className={`inline-block bg-gray-200 animate-pulse rounded ${className}`}
      >
        Loading...
      </span>
    );
  }

  if (error) {
    // Fallback to USD display on error
    const fallbackAmount = usdAmount || 0;
    return (
      <span className={className}>
        {showCurrency
          ? `$${fallbackAmount.toFixed(precision)} USD`
          : fallbackAmount.toFixed(precision)}
      </span>
    );
  }

  if (usdAmount === null || usdAmount === undefined) {
    return <span className={className}>--</span>;
  }

  if (showCurrency) {
    const formattedAmount = formatUserAmount(usdAmount, precision);
    return <span className={className}>{formattedAmount}</span>;
  }

  const displayAmount = convertUSDToUserCurrency(usdAmount);
  return <span className={className}>{displayAmount.toFixed(precision)}</span>;
};

export default UserCurrencyDisplay;
